import React from 'react';

interface LoadingSpinnerProps {
  text?: string;
}

export default function LoadingSpinner({ text = 'CARREGANDO...' }: LoadingSpinnerProps) {
  const overlayStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    zIndex: 999999,
  };

  const spinnerStyle: React.CSSProperties = {
    width: '50px',
    height: '50px',
    border: '5px solid #ccc',
    borderTop: '5px solid #102a0c',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    marginBottom: '16px',
  };

  const textStyle: React.CSSProperties = {
    color: '#FFFFFF',
    fontSize: '16px',
    fontWeight: 'bold',
  };

  return (
    <div style={overlayStyle}>
      <div style={spinnerStyle}></div>
      <div style={textStyle}>{text}</div>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}
